import { Component, Input, OnInit, ViewChild, AfterViewInit, TemplateRef, ElementRef, Host } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EasyFormComponent } from '../form/form.component';

@Component({
    selector: 'formTooltip',
    template : `
        <div class="form-tooltip">Hover over me
        <span class="form-tooltiptext">Tooltip text</span>
        </div>
    `,
    styles : [
        `
        .form-tooltip {
            position: relative;
            display: inline-block;
            border-bottom: 1px dotted black; 
        }
        
        .form-tooltip .form-tooltiptext {
            visibility: hidden;
            width: 120px;
            background-color: black;
            color: #fff;
            text-align: center;
            padding: 5px 0;
            border-radius: 6px;
         
            width: 120px;
            bottom: 100%;
            left: 50%; 
            margin-left: -60px;
        }
        
        /* Show the form-tooltip text when you mouse over the form-tooltip container */
        .form-tooltip:hover .form-tooltiptext {
            visibility: visible;
        }
        
        `
    ]
})
export class FormTooltipComponent {
    
    constructor() {
        
    }

    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/tooltip/tooltip.component.ts